import styled from 'styled-components';
import { colors, spacing } from '@izettle/otto';

const Divider = /*#__PURE__*/styled.div.withConfig({
  displayName: "divider__Divider",
  componentId: "zettle__sc-xy8i2q-0"
})(["height:1px;background-color:", ";width:100%;margin-top:", ";margin-bottom:", ";"], colors.border.divider, p => p.marginTop ?? spacing.medium, p => p.marginBottom ?? spacing.medium);

export { Divider };
//# sourceMappingURL=index.js.map
